import { Button, Space } from "antd";
import { CategoryCard } from "..";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useCallback } from "react";
import { category, topic } from "../../store";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./category.css";

const Categories = () => {
  const dispatch = useDispatch();
  const activeCategories = useSelector((state) => state.activeCategories);
  const activeTopicsCategoryId = useSelector(
    (state) => state.activeTopics.categoryId
  );
  const scrollRef = useRef();

  // Fetch categories on mount
  useEffect(() => {
    dispatch(category.categoryApi({ limit: 10, skip: 0 }));
  }, [dispatch]);

  // Auto select first category once categories are loaded and none selected
  useEffect(() => {
    if (!activeTopicsCategoryId && activeCategories.data.length > 0) {
      const first = activeCategories.data[0];
      if (first?.id) {
        dispatch(topic.topicApi({ categoryId: first.id, limit: 10, skip: 0 }));
      }
    }
  }, [activeCategories.data, activeTopicsCategoryId, dispatch]);

  const handleSelectCategory = useCallback(
    (id) => {
      if (id && id !== activeTopicsCategoryId) {
        dispatch(topic.resetPagination());
        dispatch(topic.topicApi({ categoryId: id, limit: 10, skip: 0 }));
      }
    },
    [dispatch, activeTopicsCategoryId]
  );

  const categories = activeCategories.data.map((c) => (
    <CategoryCard
      key={c.id}
      id={c.id}
      cardKey={c.id}
      category={c.name}
      active={activeTopicsCategoryId === c.id}
      onSelect={handleSelectCategory}
    />
  ));

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };

  return (
    <div
      style={{
        margin: "24px auto 32px",
        display: "flex",
        gap: "8px",
        alignItems: "center",
        maxWidth: "85%",
      }}
    >
      <Button
        icon={<LeftOutlined />}
        className="category-arrow-btn"
        onClick={scrollLeft}
      />
      <Space
        ref={scrollRef}
        className="category-space"
        direction="horizontal"
        wrap={false}
        size={8}
        style={{
          flexGrow: 2,
          margin: 0,
          justifyContent: categories.length > 4 ? "flex-start" : "center",
        }}
      >
        {categories}
      </Space>
      <Button
        icon={<RightOutlined />}
        className="category-arrow-btn"
        onClick={scrollRight}
      />
    </div>
  );
};

export default Categories;
